import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Box, Button, IconButton, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import Destruction from './Tabs/Destruction';
import Dispensation from './Tabs/Dispensation';
import Overview from './Tabs/Overview';
import Quarantine from './Tabs/Quarantine';
import Received from './Tabs/Received';
import Return from './Tabs/Return';
import Transfer from './Tabs/Transfer';
import CloseIcon from '@mui/icons-material/Close';
import { archLevel } from 'src/data/config';
import { useCommonDrugAccountability } from './useCommonDrugAccountability';
import { useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { useDispatch } from 'react-redux';
import { useUser } from 'src/components/hooks/useUser';

const KitID: React.FunctionComponent<any> = ({ setKitPageEnable, singleKitData }: any) => {
  const temp = singleKitData;
  const handleBackButton = () => {
    setKitPageEnable(true);
  };
  const [returnPopupEvent, setReturnPopupEvent] = useState(false);
  const [distroyPopupEvent, setDistroyPopupEvent] = useState(false);
  const [recivedPopupEvent, setRecivedPopupEvent] = useState(false);
  const [transferPopupEvent, setTransferPopupEvent] = useState(false);
  const [quarantinePopupEvent, setQuarantinePopupEvent] = useState(false);
  const [pendingTransfers, setPendingTransfers] = useState(0);
  const [value, setValue] = React.useState('1');
  const [alertMessageOpen, setAlertMessageOpen] = useState(true);

  const dispatch = useDispatch();

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG;
  const { email } = useUser();

  const tabData: any[] = [
    { label: 'Overview', value: '1' },
    { label: 'Received', value: '2' },
    { label: 'Dispensation', value: '3' },
    { label: 'Return', value: '4' },
    { label: 'Destruction', value: '5' },
    { label: 'Transfer', value: '6' },
    { label: 'Quarantine', value: '7' }
  ];
  const tabpanelData: any[] = [
    { value: '1', cmp: Overview },
    { value: '2', cmp: Received },
    { value: '3', cmp: Dispensation },
    { value: '4', cmp: Return },
    { value: '5', cmp: Destruction },
    { value: '6', cmp: Transfer },
    { value: '7', cmp: Quarantine }
  ];
  const { checkPermission } = usePermissionWrapper();
  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleEventClick = () => {
    if (value == '2') {
      setRecivedPopupEvent(true);
    }
    if (value == '4') {
      setReturnPopupEvent(true);
    }
    if (value == '5') {
      setDistroyPopupEvent(true);
    }
    if (value == '6') {
      setTransferPopupEvent(true);
    }
    if (value == '7') {
      setQuarantinePopupEvent(true);
    }
  };

  const { getDrugEventRecords } = useCommonDrugAccountability();

  const getAllDrugEventsData = async (from: number, size: number) => {
    const result: any = await getDrugEventRecords({
      site_id: selectedSite,
      study_id: studyId,
      kit_id: singleKitData.da_log_kit_id,
      country: selectedCountry,
      application: currentAppName,
      da_log_kit_event: 'Transferred',
      from,
      size
    });
    if (result?.isSuccess) {
      setPendingTransfers(
        result.data.selected_data.filter(
          (item: any) =>
            item?.event_data?.da_log_kit_send_to?.includes(email) &&
            item?.event_data?.da_log_kit_status == 'Pending Approval'
        ).length
      );
    } else if (result?.isError) {
      if (result?.error?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
  };

  useEffect(() => {
    getAllDrugEventsData(0, -1);
  }, [selectedSite]);

  return (
    <div>
      <Button onClick={handleBackButton}>
        <ArrowBackIcon fontSize="small" /> &nbsp; ALL KITS
      </Button>
      {archLevel == 'sponsor' && pendingTransfers > 0 && alertMessageOpen && (
        <Alert
          severity="info"
          sx={{ mb: 1 }}
          action={
            <>
              <Button color="inherit" size="small" onClick={() => setValue('6')}>
                <b>Go To Request</b>
              </Button>
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setAlertMessageOpen(false);
                }}
                sx={{ ml: 2 }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </>
          }
        >
          <b>Pending Transfer Request ({pendingTransfers})</b>
        </Alert>
      )}
      <h3>
        Kit ID # {temp.da_log_kit_id} - {temp.da_log_location} - {temp.da_log_lot_num}
      </h3>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        {(value != '1' && value === '4' && checkPermission('update_kit_return_event')) ||
        (value === '5' && checkPermission('update_kit_destruction_event')) ||
        (value === '2' && checkPermission('update_kit_received_event')) ||
        (value === '6' && checkPermission('update_kit_transfer_event')) ||
        (value === '7' && checkPermission('update_kit_quarantine_event')) ? (
          <Button style={{ float: 'right' }} variant="contained" onClick={handleEventClick}>
            ADD Event
          </Button>
        ) : (
          ''
        )}
        <TabContext value={value}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" className="tabsFontSize">
            {tabData.map((ele: any) => (
              <Tab key={ele.value} label={ele.label} value={ele.value} />
            ))}
          </TabList>
          {tabpanelData.map((ele: any) => (
            <TabPanel sx={{ p: 0 }} key={ele.value} value={ele.value}>
              <ele.cmp
                kitData={temp}
                index={ele.value}
                returnPopupEvent={returnPopupEvent}
                setReturnPopupEvent={setReturnPopupEvent}
                distroyPopupEvent={distroyPopupEvent}
                setDistroyPopupEvent={setDistroyPopupEvent}
                recivedPopupEvent={recivedPopupEvent}
                setRecivedPopupEvent={setRecivedPopupEvent}
                setValue={setValue}
                transferPopupEvent={transferPopupEvent}
                setTransferPopupEvent={setTransferPopupEvent}
                quarantinePopupEvent={quarantinePopupEvent}
                setQuarantinePopupEvent={setQuarantinePopupEvent}
                setPendingTransfers={setPendingTransfers}
              />
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </div>
  );
};

export default KitID;
